import React from 'react';

import { Autocomplete, Checkbox, TableCell, TableRow, TextField } from '@mui/material';

import { EGS_GUEST_TYPE_LABELS } from '../tabs/egs/fields';
import type { EgsRoomRow } from '../tabs/egs/previousEgs';

export type EgsRoomsChange = (key: string, rooms: Array<string>) => void;

export type EgsSkipChange = (key: string, skipped: boolean) => void;

type CopyEgsRoomsRowProps = {
  onRoomsChange: EgsRoomsChange;
  onSkipChange: EgsSkipChange;
  roomNames: Array<string>;
  row: EgsRoomRow;
  rooms: Array<string>;
  skipped: boolean;
};

export default function CopyEgsRoomsRow({
  onRoomsChange,
  onSkipChange,
  roomNames,
  row,
  rooms,
  skipped,
}: CopyEgsRoomsRowProps) {
  const missingRooms = !skipped && !rooms.length;

  function handleChange(_event: React.SyntheticEvent, value: Array<string>) {
    onRoomsChange(row.key, value);
  }

  function handleSkipChange(event: React.ChangeEvent<HTMLInputElement>) {
    onSkipChange(row.key, event.target.checked);
  }

  return (
    <TableRow>
      <TableCell>{row.name || 'No name'}</TableCell>
      <TableCell>{row.guestTypes.map((guestType) => EGS_GUEST_TYPE_LABELS[guestType]).join(', ')}</TableCell>
      <TableCell sx={{ minWidth: 280 }}>
        <Autocomplete
          disableCloseOnSelect
          disabled={skipped}
          multiple
          onChange={handleChange}
          options={roomNames}
          renderInput={(params) => (
            <TextField
              {...params}
              error={missingRooms}
              helperText={missingRooms ? 'Pick at least one room' : undefined}
              placeholder={rooms.length ? undefined : 'Pick rooms'}
            />
          )}
          size="small"
          value={rooms}
        />
      </TableCell>
      <TableCell padding="checkbox">
        <Checkbox
          checked={skipped}
          inputProps={{ 'aria-label': `Skip ${row.name}` }}
          onChange={handleSkipChange}
          size="small"
        />
      </TableCell>
    </TableRow>
  );
}
